'use client';
import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { ThemeProvider } from 'next-themes';
import { PropsWithChildren, useState } from 'react';
import { CommandPalette } from '@/components/command-palette';
import { PostHogIdentity } from '@/components/posthog-identity';
import { TourProvider } from '@/components/tour/tour-provider';
import { reportError } from '@/lib/report-error';

export function Providers({ children }: PropsWithChildren) {
  const [client] = useState(
    () =>
      new QueryClient({
        // Global reporting only; per-call onError handlers (toasts, rollbacks)
        // still run in addition.
        queryCache: new QueryCache({
          onError: (error, query) =>
            reportError(error, {
              source: 'react-query',
              query_key: JSON.stringify(query.queryKey),
            }),
        }),
        mutationCache: new MutationCache({
          onError: (error, _variables, _context, mutation) =>
            reportError(error, {
              source: 'react-query-mutation',
              mutation_key: mutation.options.mutationKey
                ? JSON.stringify(mutation.options.mutationKey)
                : undefined,
            }),
        }),
      })
  );
  return (
    <>
      <PostHogIdentity />
      <ThemeProvider attribute="class" defaultTheme="dark" enableSystem>
        <QueryClientProvider client={client}>
          <TourProvider>{children}</TourProvider>
          <CommandPalette />
        </QueryClientProvider>
      </ThemeProvider>
    </>
  );
}
